import { format, isValid, parseISO } from "date-fns";

export function formatTrackingDate(value) {
  if (!value) return "—";
  const d = parseISO(String(value));
  return isValid(d) ? format(d, "dd MMM yyyy") : String(value);
}

export function formatTrackingAmount(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return `₹${n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function isDonationApproved(row) {
  return Number(row?.payment_status) === 1 || row?.status === "Approved";
}

export function computeApprovalPercent(pending, approved) {
  const total = Number(pending) + Number(approved);
  if (total <= 0) return 0;
  return Math.round((Number(approved) / total) * 100);
}
